// ============================================
// KPI Section Component
// ============================================

import { DollarSign, Users, Target, MessageCircle, Eye, Percent } from 'lucide-react';
import { KPICard, KPIGrid } from '../../../components/dashboard/KPICard';
import { KPICardSkeleton } from '../../../components/layout/LoadingState';
import type { DashboardKPIs } from '../../../types/api';

interface KPISectionProps {
  data?: DashboardKPIs;
  isLoading: boolean;
}

export function KPISection({ data, isLoading }: KPISectionProps) {
  if (isLoading || !data) {
    return (
      <KPIGrid columns={4}>
        {Array.from({ length: 4 }).map((_, i) => (
          <KPICardSkeleton key={i} />
        ))}
      </KPIGrid>
    );
  }

  return (
    <KPIGrid columns={4}>
      <KPICard
        title="Tổng Chi Tiêu"
        data={data.totalSpend}
        format="currency"
        metricType="cost"
        icon={<DollarSign className="w-5 h-5" />}
        subtitle="Facebook Ads"
      />
      <KPICard
        title="Tổng Messages"
        data={data.totalMessages}
        format="number"
        metricType="growth"
        icon={<MessageCircle className="w-5 h-5" />}
        subtitle="Tin nhắn từ quảng cáo"
      />
      <KPICard
        title="Chi Phí / Message"
        data={data.costPerMessage}
        format="currency"
        metricType="cost"
        icon={<Target className="w-5 h-5" />}
        subtitle="Thấp hơn = tốt hơn"
      />
      <KPICard
        title="Tổng Leads"
        data={data.totalLeads}
        format="number"
        metricType="growth"
        icon={<Users className="w-5 h-5" />}
        subtitle="Từ quảng cáo"
      />
    </KPIGrid>
  );
}

// ============================================
// Extended KPI Section (8 metrics)
// ============================================

interface ExtendedKPISectionProps {
  data?: DashboardKPIs;
  isLoading: boolean;
}

export function ExtendedKPISection({ data, isLoading }: ExtendedKPISectionProps) {
  if (isLoading || !data) {
    return (
      <KPIGrid columns={4}>
        {Array.from({ length: 8 }).map((_, i) => (
          <KPICardSkeleton key={i} />
        ))}
      </KPIGrid>
    );
  }

  return (
    <KPIGrid columns={4}>
      <KPICard
        title="Tổng Chi Tiêu"
        data={data.totalSpend}
        format="currency"
        metricType="cost"
        icon={<DollarSign className="w-5 h-5" />}
      />
      <KPICard
        title="Tổng Messages"
        data={data.totalMessages}
        format="number"
        metricType="growth"
        icon={<MessageCircle className="w-5 h-5" />}
      />
      <KPICard
        title="Chi Phí / Message"
        data={data.costPerMessage}
        format="currency"
        metricType="cost"
        icon={<Target className="w-5 h-5" />}
      />
      <KPICard
        title="Tổng Leads"
        data={data.totalLeads}
        format="number"
        metricType="growth"
        icon={<Users className="w-5 h-5" />}
      />
      <KPICard
        title="Chi Phí / Lead"
        data={data.costPerLead}
        format="currency"
        metricType="cost"
        icon={<Target className="w-5 h-5" />}
      />
      <KPICard
        title="CTR"
        data={data.ctr}
        format="percent"
        metricType="growth"
        icon={<Percent className="w-5 h-5" />}
      />
      <KPICard
        title="Impressions"
        data={data.totalImpressions}
        format="number"
        metricType="growth"
        icon={<Eye className="w-5 h-5" />}
      />
      <KPICard
        title="Reach"
        data={data.totalReach}
        format="number"
        metricType="growth"
        icon={<Eye className="w-5 h-5" />}
      />
    </KPIGrid>
  );
}
